import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  DateInterval,
  FollowerPointOfSale,
  FollowerPointOfSaleForm,
  Page
} from '../models';

@Injectable({
  providedIn: 'root'
})
export class FollowerPointOfSaleService {

  url = environment.dns + 'follower-point-of-sale';

  constructor(private http: HttpClient) { }

  add(follower: FollowerPointOfSaleForm): Observable<FollowerPointOfSale> {
    return this.http.post<FollowerPointOfSale>(this.url, follower);
  }

  update(follower: FollowerPointOfSaleForm): Observable<FollowerPointOfSale> {
    return this.http.put<FollowerPointOfSale>(this.url, follower);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.url}/${id}`);
  }

  getOne(id: number): Observable<FollowerPointOfSale> {
    return this.http.get<FollowerPointOfSale>(`${this.url}/${id}`);
  }

  getPaginate(page: number, size: number, search: string): Observable<Page<FollowerPointOfSale>> {
    return this.http.get<Page<FollowerPointOfSale>>(`${this.url}/paginate?page=${page}&size=${size}&search=${search || ''}`);
  }

  getListByCommercial(commercialId: number): Observable<FollowerPointOfSale[]> {
    return this.http.get<FollowerPointOfSale[]>(`${this.url}/commercial/${commercialId}`);
  }

  getListByPeriod(dateInterval: DateInterval): Observable<FollowerPointOfSale[]> {
    return this.http.post<FollowerPointOfSale[]>(`${this.url}/period`, dateInterval);
  }
}
